import ChildrenEntities from 'publisher/components/ChildrenEntities'
import { useWebsiteSettings } from 'publisher/store'
import React from 'react'
import {
  getWebsiteStylesLayout,
  getWebsiteThemeBackground,
} from 'src/publisher/store/website-settings/website-settings-selector'
import { CommonWebsitePageBody } from 'src/shared/entities/website-page-body'
import { WebsitePageInterface } from 'src/shared/types/website-entities'
import { getBackgroundImageStyleValue } from 'src/shared/utils/get-background-style-by-file'

export interface WebsitePageBodyProps {
  entity: WebsitePageInterface
}

export const WebsitePageBody = ({ entity }: WebsitePageBodyProps) => {
  const layout = useWebsiteSettings(getWebsiteStylesLayout)
  const background = useWebsiteSettings(getWebsiteThemeBackground)
  const backgroundImage = getBackgroundImageStyleValue(
    background?.pageBackgroundPicture?.file,
  )

  return (
    <CommonWebsitePageBody
      htmlAttrId={entity.htmlAttrId}
      contentWidth={layout?.contentWidth}
      backgroundImage={backgroundImage}
      background={
        background?.containerBackgroundColor ||
        background?.contentBackgroundColor
      }
      pageBackground={background?.pageBackgroundColor}
    >
      <ChildrenEntities childIds={entity.childIds} />
    </CommonWebsitePageBody>
  )
}
